import { makeStyles } from "@fluentui/react";
import { IPanelEditarElemento } from "../editarElemento/PanelEditarElemento";
import { UsePanelOcutarElemento } from "./UsePanelOcutarElemento";
import { useCallback } from "react";
import { PanelFooter } from "../../../../../components/Panel/PanelFooter";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { Body1 } from "@fluentui/react-components";
import { Warning24Filled } from "@fluentui/react-icons";

const useStyles = makeStyles({
    container: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignContent: "center",
      top: "100%",
      alignItems: "center",
    },
  
    warning: {
      color: " #eaa300",
      width: "60px",
      height: "60px",
    },
  });
export const PanelOcutarElemento=(props:IPanelEditarElemento)=>{
    const styles = useStyles();
    const {request,setRequest,putEditarCatalogo,loading,reset,mensaje,status} = UsePanelOcutarElemento(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            <PanelFooter
              texto={props.item.esOculto?"Habilitar":"Ocultar"}
              texto2={"Salir"}
              onClick={putEditarCatalogo}
              onDismiss={() => {
                reset()
              }}
            />
          </>
        ),
        [request]
      );
    return (
        <PanelDrawer
          isOpen={props.isOpen}
          onDismiss={reset}   
          textHeader={props.item.esOculto?"Habilitar Elemento":"Ocultar Elemento"}
          status={status}
          mensaje={mensaje}
          loading={loading}
          onRenderFooter={onRenderFooter}
        >
         <>
                    <div className={styles.container}>
                      <div>
                        <Warning24Filled className={styles.warning} />
                      </div>
                      <div>
                        <Body1>
                          ¿Desea 
                             {props.item.esOculto?" habilitar":" ocultar"} el Catalogo: {props.item.nombreElementoEstandar}?
                        </Body1>
                      </div>
                    </div>
                  </>
       </PanelDrawer>
    )
}